/******************************************************************
 * Archivo : client/src/components/Admin/surveys/SurveyViewer/index.js
 * Proyecto: CB30
 ******************************************************************/

import React, { Component } from "react";
import { graphql, compose } from "react-apollo";

// Queries
import viewerUsersQuery from "../../../../queries/fetchViewerUsers";
import viewerSurveyResultQuery from "../../../../queries/fetchViewerSurveyResult";
import ViewerResultContainer from "./ViewerResult/ViewerResultContainer";
import ViewerUserContainer from "./ViewerUser/ViewerUserContainer";




class SurveyViewer extends Component {

state = {
  filtro: "",
  usuarioSeleccionado: null,
  encuestaSeleccionada: null,
  encuestaAbierta: false,
  respuestasEncuesta: []
  
};

  renderUsers() {

    const users = (this.props.data.viewerUsers || [])

      .sort((a, b) =>
        (a.nombre || "").localeCompare(b.nombre || "")
      )

      .filter(user => {

        const texto = this.state.filtro.toLowerCase();

        return (
          (user.nombre || "").toLowerCase().includes(texto) ||
          (user.apellido || "").toLowerCase().includes(texto) ||
          (user.email || "").toLowerCase().includes(texto)
        );

      });

    return users.map(user => (

      <tr
        key={user.id}
        style={{ cursor: "pointer" }}
        onClick={() =>
          this.setState({
            usuarioSeleccionado: user
          })
        }
      >

        <td>{user.nombre}</td>

        <td>{user.apellido}</td>

        <td>{user.email}</td>

      </tr>

    ));

  }

  render() {

    if (this.props.data.loading) {
      return <div className="loader">Loading...</div>;
    }

    if (this.props.data.error) {
      return <div>{this.props.data.error.message}</div>;
    }

    return (

      <div className="container">

        <h1>Visor Universal</h1>

        <hr />

        <div className="form-group">

          <label>
            <strong>Buscar informante</strong>
          </label>

          <input
            className="form-control"
            placeholder="Nombre, apellido o correo..."
            value={this.state.filtro}
            onChange={e =>
              this.setState({
                filtro: e.target.value
              })
            }
          />

        </div>

        <br />

        {
          !this.state.usuarioSeleccionado && (

            <table className="table table-hover table-sm">

              <thead>

                <tr>

                  <th>Nombre</th>

                  <th>Apellido</th>

                  <th>Correo</th>

                </tr>

              </thead>

              <tbody>

                {this.renderUsers()}

              </tbody>

            </table>

          )
        }

        {
          this.state.usuarioSeleccionado && (

            <div className="card">

            <div className="card-header d-flex justify-content-between align-items-center">
              <strong>Informante seleccionado</strong>

              <a
                href={`${process.env.NODE_ENV === "production" ? "" : "http://localhost:5000"}/survey/viewer/${this.state.usuarioSeleccionado.id}/pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-danger"
              >
              Ver / Descargar PDF
            </a>
            </div>

              <div className="card-body">

                <p>
                  <strong>Nombre:</strong>{" "}
                  {this.state.usuarioSeleccionado.nombre}
                </p>

                <p>
                  <strong>Apellido:</strong>{" "}
                  {this.state.usuarioSeleccionado.apellido}
                </p>

                <p>
                  <strong>Correo:</strong>{" "}
                  {this.state.usuarioSeleccionado.email}
                </p>

                <p>
                  <strong>Id:</strong>{" "}
                  {this.state.usuarioSeleccionado.id}
                </p>

                <p>
                  <strong>Encuestas respondidas:</strong>{" "}
                  {this.state.usuarioSeleccionado.surveys.length}
                </p>

                <hr />

                <ViewerUserContainer
                 usuarioId={this.state.usuarioSeleccionado.id}
                />

<h5>Encuestas</h5>

<ul className="list-group">

  {
    this.state.usuarioSeleccionado.surveys.map((survey, index) => (

      <li
        key={index}
        className="list-group-item d-flex justify-content-between align-items-center"
      >

        {survey.titulo}

      <button
        className="btn btn-sm btn-primary"
  onClick={() =>
    this.setState({
      encuestaSeleccionada: survey,
      encuestaAbierta: !(
        this.state.encuestaAbierta &&
        this.state.encuestaSeleccionada &&
        this.state.encuestaSeleccionada.surveyResultsId === survey.surveyResultsId
      )
    })
      }
      >
        {
          this.state.encuestaAbierta &&
          this.state.encuestaSeleccionada &&
          this.state.encuestaSeleccionada.surveyResultsId === survey.surveyResultsId
            ? "Ocultar"
            : "Ver"
        }
      </button>

      </li>

    ))
  }

</ul>

      {
        this.state.encuestaSeleccionada &&
        this.state.encuestaAbierta && (
          <ViewerResultContainer
            encuesta={this.state.encuestaSeleccionada}
          />
        )
      }

              </div>

              

            </div>

          )
        }

      </div>

    );

  }

}

export default graphql(viewerUsersQuery)(SurveyViewer);


// WEBPACK FOOTER //
// ./src/components/Admin/surveys/SurveyViewer/index.js